module.exports = __webpack_public_path__ + "static/media/email.cc5498d1.svg";